import type React from "react";
import type { ValidationError } from "../validation/types";

export interface ValidationErrorsTableProps {
  errors: ValidationError[];
  className?: string;
}

const ValidationErrorsTable: React.FC<ValidationErrorsTableProps> = ({
  errors,
  className = "",
}) => {
  const displayErrors = errors.slice(0, 10);
  const hasMore = errors.length > 10;

  return (
    <div
      className={`import-payslip-events__validation-errors ${className}`.trim()}
      role="region"
      aria-label="Validation errors"
    >
      <p className="import-payslip-events__validation-errors-message">
        Found {errors.length} error{errors.length !== 1 ? "s" : ""}. Please fix
        and upload again.
      </p>
      <div className="import-payslip-events__validation-errors-table-wrapper">
        <table className="import-payslip-events__validation-errors-table">
          <thead>
            <tr>
              <th scope="col">Row #</th>
              <th scope="col">Column</th>
              <th scope="col">Error</th>
            </tr>
          </thead>
          <tbody>
            {displayErrors.map((err, index) => (
              <tr key={`${err.row}-${err.column}-${index}`}>
                <td>{err.row === 0 ? "—" : err.row}</td>
                <td>{err.column || "—"}</td>
                <td>{err.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {hasMore && (
        <p className="import-payslip-events__validation-errors-truncated">
          Showing first 10 of {errors.length} errors.
        </p>
      )}
    </div>
  );
};

export default ValidationErrorsTable;
